/**
 * BaseRepository는 모든 Repository의 기본이 되는 클래스입니다.
 */
export class BaseRepository {
  constructor() {
    if (this.constructor === BaseRepository) {
      throw new Error('BaseRepository는 직접 인스턴스화할 수 없습니다.');
    }
  }

  /**
   * 데이터를 생성합니다.
   * @param {Object} data - 생성할 데이터
   * @returns {Promise<Object>} 생성된 데이터
   */
  async create(data) {
    throw new Error('create 메서드를 구현해야 합니다.');
  }

  /**
   * ID로 데이터를 조회합니다.
   * @param {string|number} id - 조회할 데이터의 ID
   * @returns {Promise<Object>} 조회된 데이터
   */
  async getById(id) {
    throw new Error('getById 메서드를 구현해야 합니다.');
  }

  /**
   * 모든 데이터를 조회합니다.
   * @returns {Promise<Array>} 조회된 데이터 배열
   */
  async getAll() {
    throw new Error('getAll 메서드를 구현해야 합니다.');
  }

  /**
   * 데이터를 업데이트합니다.
   * @param {string|number} id - 업데이트할 데이터의 ID
   * @param {Object} data - 업데이트할 데이터
   * @returns {Promise<Object>} 업데이트된 데이터
   */
  async update(id, data) {
    throw new Error('update 메서드를 구현해야 합니다.');
  }

  /**
   * 데이터를 삭제합니다.
   * @param {string|number} id - 삭제할 데이터의 ID
   * @returns {Promise<boolean>} 삭제 성공 여부
   */
  async delete(id) {
    throw new Error('delete 메서드를 구현해야 합니다.');
  }
} 